module.exports = "/_next/static/images/seafood-96c27384749c7b1f6d0c8e4dadd1b79b.jpg";